module.exports = __webpack_public_path__ + "html/bg-video_38f9ba03e95ed35fb68e725570a4de22.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/bg-video.html
// module id = hLeG
// module chunks = 43